<template>
  <!--//@*/*
      //    *RPD  App v0.91
      //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
      //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
      //    */
      //-->

  <!-- RECORDS FEE SCHEDULES!! DO A SEARCH FOR 'FEE SCHEDULE' THERE ARE 5 PLACES -->
  <v-expansion-panel popout class="mt-4">
    <v-expansion-panel-header
      id="rec_fee_schdl"
      @click="onExpansionPanelClick"
      class="accent white-text text-body2 text-md-h6"
      >RECORDS FEE SCHEDULE
      <template v-slot:actions>
        <v-icon color="white" x-large> $expand </v-icon>
      </template></v-expansion-panel-header
    >
    <v-expansion-panel-content color="grey lighten-5">
      <div class="bcs-expansion-content mt-4">
        <div class="mt-6 text-body2 text-sm-h6 text-md-h6">
          FY 25-26
          <a
            href="https://renopd.com/formAdmin/content/pdfs_lib/FY25.26_Fee_Schedule_07_2025.pdf"
            target="_blank"
            >RECORDS FEE SCHEDULE</a
          >
        </div>
      </div>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<style lang="scss" scoped>
@import "../scss/site.scss";
.bcs-expansion-content {
  color: black;
}
</style>
<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "rec_fee_schdl",
  mixins: [bus_common],
  data: function () {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    onExpansionPanelClick(event) {
      this.$emit("onExpansionPanelClick", event);
    },
    init: function () {
      this.show_loader(false);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
      // The whole view is rendered, so I can safely access or query
      // the DOM. ¯\_(ツ)_/¯
    });
  },
};
</script>
